import React, { useId } from 'react';
export default function WikiChatMark({
  size = 24
}) {
  const cutout = useId();
  const bubble = "M20 19h12a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-4l-5 4v-4h-3a4 4 0 0 1-4-4v-8a4 4 0 0 1 4-4Z";
  return <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true"><defs><mask id={cutout} maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"><rect width="40" height="40" fill="white" /><path d={bubble} fill="black" stroke="black" strokeWidth="4" strokeLinejoin="round" /></mask></defs><g mask={`url(#${cutout})`} stroke="currentColor" strokeWidth="1.9" strokeLinecap="round"><rect x="5" y="4" width="24" height="27" rx="5" /><path d="M11 11h12M11 16h7" /></g><path d={bubble} fill="currentColor" /></svg>;
}
